
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { ProfileFilter } from 'client-website-ts-library/filters';
import { Profile, WebsiteLevel, WebsiteProfileDisplayType } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';
import { AsyncView, View } from 'client-website-ts-library/plugins';

import Panels from '@/components/Panels.vue';
import ProfileCards from '../components/ProfileCards.vue';
import Loader from '../components/UI/Loader.vue';

@Component({
  components: {
    ProfileCards,
    Loader,
    Panels,
  },
})
export default class OfficeOurAgents extends Mixins(AsyncView) {
  private profiles: Profile[] = [];

  mounted() {
    const id = this.$route.params.id;

    if (id) {
      API.Slugs.Resolve(id).then((resolved) => {
        if (resolved.Type === 'Office') {
          this.updateProfiles(WebsiteLevel.Office, resolved.Id);

          // City
          if (resolved.Id === '91b553f9-7cbc-4697-bf7d-d70714b674a4') {
            this.updateProfiles(WebsiteLevel.Office, '29d9080e-165e-4372-afc4-374f5b90fdde'); // City Rentals
            const index = this.profiles.findIndex((p) => p.Id === 'dbc21df2-268d-43da-a26c-da5711f7ee39');
            this.profiles[index].DisplayType = WebsiteProfileDisplayType.Agent;
          }

          // Redlynch
          if (resolved.Id === 'f2c947c3-1b35-41ce-8380-54f0ff32cd52') {
            this.updateProfiles(WebsiteLevel.Office, '4e9814df-12f6-4c08-b411-1499c2b952c9'); // Redlynch Rentals
          }

          // South
          if (resolved.Id === 'f9d229bb-51ff-4b83-94eb-4877c1c736d2') {
            API.Profiles.Get('998d6fdc-8b5e-4864-9d82-ba9efb3c6629', true).then((profile) => {
              this.profiles.push(profile);
            }); // Greg
          }
        }
      });
    } else {
      this.updateProfiles(WebsiteLevel.Franchise, Config.Website.Settings!.WebsiteId);
    }
  }

  updateProfiles(searchLevel: WebsiteLevel, id: string) {
    API.Profiles.Search(new ProfileFilter({
      SearchLevel: searchLevel,
      SearchGuid: id,
    }), true).then((profiles) => {
      this.profiles = this.profiles.concat(profiles);
      // City
      if (id === '91b553f9-7cbc-4697-bf7d-d70714b674a4') {
        const index = this.profiles.findIndex((p) => p.Id === 'dbc21df2-268d-43da-a26c-da5711f7ee39');
        this.profiles[index].DisplayType = WebsiteProfileDisplayType.Agent;
      }
    });
  }

  get directors(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Principal);
  }

  get agents(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.Agent);
  }

  get propertyManagers(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PropertyManager);
  }

  get support(): Profile[] {
    return this.profiles.filter((p) => p.DisplayType === WebsiteProfileDisplayType.PersonalAssistant);
  }
}
